module.exports = __webpack_public_path__ + "static/media/disponivel-google-play.fea33b49.svg";